import React, { FC } from 'react';

import Popper from '@zvuk-b2b/react-uikit/ui/Popper';
import useMedia from '@zvuk-b2b/react-uikit/toolkit/useMedia';

import { PointItemContentType } from './types';
import ItemContent from './ItemContent';

import styles from './index.module.scss';
import { getPopperPlacement } from './utils';

const PointItemContent: FC<PointItemContentType> = ({
  currentItem,
  isLoading,
  showStreamData = false,
  className,
  hintText,
  hintIconNearSelector,
  parentRef,
  showHint,
  disabled = false,
}) => {
  const { isDesktop } = useMedia();

  if (showHint && hintText) {
    return (
      <Popper
        triggerNode={
          <div>
            <ItemContent
              className={className}
              currentItem={currentItem}
              isLoading={isLoading}
              showStreamData={showStreamData}
              showHint={showHint}
              hintIconNearSelector={hintIconNearSelector}
              disabled={disabled}
            />
          </div>
        }
        isShow
        placement={getPopperPlacement(isDesktop, Boolean(hintIconNearSelector))}
        delayShow={400}
        delayHide={400}
        portalNode={document.body}
        containerClassName={styles.popperWrapper}
        isShowingOnClick
        parentRef={parentRef}>
        {hintText}
      </Popper>
    );
  }

  return (
    <ItemContent
      className={className}
      currentItem={currentItem}
      isLoading={isLoading}
      showStreamData={showStreamData}
      showHint={showHint}
      hintIconNearSelector={hintIconNearSelector}
      disabled={disabled}
    />
  );
};

export default React.memo(PointItemContent);
